import { Box } from "@mui/material";
import styles from "./style.module.css";
import SkillsList from "./skills-list";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useProfileComplete from "../../../../../hooks/useProfileComplete";
import { updateProfileCompleteData } from "../../../../../store/slices/profile/profileCompleteSlice";

const SkillsBar = () => {
  const dispatch = useDispatch();
  const { userSkills } = useSelector((state) => state.user);
  useProfileComplete();

  const handleSkillsChange = () => {
    userSkills.map((skill) => {
      if (
        skill?.name &&
        skill?.description &&
        skill?.level &&
        skill?.startedTrainingAge
      ) {
        dispatch(updateProfileCompleteData({ skillComplete: true }));
      } else {
        dispatch(updateProfileCompleteData({ skillComplete: false }));
      }
    });
  };

  useEffect(() => {
    handleSkillsChange();
  }, [userSkills]);

  return (
    <Box className={styles.skills}>
      <SkillsList />
    </Box>
  );
};

export default SkillsBar;
